"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Capsule = function Capsule(props) {
  var _classNames;

  var className = props.className,
      colour = props.colour,
      size = props.size,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ["className", "colour", "size", "children"]);

  var capsuleClass = (0, _classnames.default)('capsule', className, (_classNames = {}, _defineProperty(_classNames, "-".concat(colour), colour), _defineProperty(_classNames, '-small', size === _constants.capsuleSizes.SMALL), _classNames));
  return _react.default.createElement("div", _extends({
    className: capsuleClass
  }, otherProps), children);
};

Capsule.displayName = 'Capsule';
Capsule.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  colour: _propTypes.default.oneOf(Object.values(_constants.capsuleColours)),
  size: _propTypes.default.oneOf(Object.values(_constants.capsuleSizes))
};
var _default = Capsule;
exports.default = _default;